import { SET_USER, DELETE_USER, 
  UPDATE_USER 
} from '../constants/actionTypes.js';
// import memberstack from '../memberstack.js';
import * as api from '../api/index.js';

export const setUser = (memberData) => async (dispatch) => {
    try {
    //   const member = await memberstack.getCurrentMember();
      // member will contain the user object (member ID, email, etc.) if logged in,
      // or null if not logged in.
      dispatch({ type: SET_USER, payload: memberData });
    } catch (error) {
      console.error("Error fetching user from Memberstack:", error);
    }
  };

export const deleteUser = (details) => async (dispatch) => {
  try {
     try {
    const { data } = await api.deleteUser(details);   
    dispatch({ type: DELETE_USER, payload: data });
    return { ok: true };
  } catch (error) {
    const msg =
      error.response?.data?.error || 'Something went wrong. Please try again.';
    return { ok: false, msg };        
  }
  } catch (error) {
    console.log(error);
  }
};

// export const updateUser = (updatedData) => async (dispatch) => {
//   try {
//     const { data } = await api.updateUser(updatedData);

    
//     // Then dispatch the updated user data to Redux.
//     dispatch({ type: UPDATE_USER, payload: data });
//   } catch (error) {
//     console.error('Error updating user:', error);
//   }
// };

export const updateUser = (updatedData) => async (dispatch) => {
  try {
    const { data } = await api.updateUser(updatedData);
    dispatch({ type: UPDATE_USER, payload: data });
    return { ok: true, data };
  } catch (error) {
    const msg =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      'Error updating user. Please try again.';
    console.error('Error updating user:', msg);
    return { ok: false, msg };
  }
};


export const subscribe = (formData) => async () => {
  try {
    const { data: htmlForm } = await api.createSubscription(formData);
    document.body.insertAdjacentHTML('beforeend', htmlForm);
    document.getElementById('autoPayHereForm').submit();
  } catch (error) {
    console.error('Error initiating subscription:', error);
  }
};


export const updateUserDetails = (details) => async (dispatch) => {
  try {
    const { data } = await api.updateUserDetails(details);
    // overwrite user in Redux with fresh version from backend
    dispatch({ type: UPDATE_USER, payload: data });
    console.log(data);
    
    return data;
  } catch (error) {
    console.error('Error updating user details:', error);
    return null;
  }
};


export const changePayment = (payload) => async (dispatch) => {
  try {
    const { data } = await api.changePaymentMethod(payload);

    // same pattern as subscribe(): inject PayHere form + submit it
    if (typeof document !== 'undefined') {
      const wrapper = document.createElement('div');
      wrapper.innerHTML = data;
      document.body.appendChild(wrapper);

      const form = wrapper.querySelector('#autoPayHereForm');
      if (form) form.submit();
      else console.error('Change payment form not found');
    }

    return { ok: true };
  } catch (err) {
    console.error('changePayment failed:', err);
    return { ok: false, msg: err?.response?.data || err.message };
  }
};